<template>
  <el-card>
    <div>
      <i class="q-icon fa fa-user"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>Account Management</el-breadcrumb-item>
        <el-breadcrumb-item>Edit Password</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="addForm" :model="editData" :rules="rules" class="addForm" label-width="100px">
      <el-form-item label=" ">
      </el-form-item>
      <el-form-item label="Old PWD" prop="oldpassword">
        <el-input v-model="editData.oldpassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="New PWD" prop="newpassword">
        <el-input v-model="editData.newpassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="Conf. PWD" prop="newpassword2">
        <el-input v-model="editData.newpassword2" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancelFun">Cancel</el-button>
        <el-button type="primary" @click="sureFun">Confirm</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import userApi from "@/api/user.js";

export default {
  data: function () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please Comfirm New PWD'));
      } else if (value !== this.editData.newpassword) {
        callback(new Error('The two entered pwd do not match!'));
      } else {
        callback();
      }
    };
    return {
      editData: {
        oldpassword: "",
        newpassword: "",
        newpassword2: "",
      },
      rules: {
        oldpassword: [
          {required: true, message: "Please fill old pwd", trigger: "blur"}
        ],
        newpassword: [
          {required: true, message: "Please fill new pwd", trigger: "blur"}
        ],
        newpassword2: [
          {required: true, validator: validatePass2, trigger: "blur"}
        ]
      }
    };
  },
  computed: {
    userId() {
      return this.$store.state.login.userid;
    },
    userName() {
      return this.$store.state.login.username;
    }
  },
  created() {
    // 进入页面，隐藏侧边栏
    this.$store.commit('SET_ASIDEHIDDEN', true)
  },
  methods: {
    cancelFun() {
      this.$store.commit('SET_ASIDEHIDDEN', false)
      this.$router.go(-1); //返回上一层
    },
    sureFun() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let params = {
            oldpassword: this.editData.oldpassword,
            newpassword: this.editData.newpassword
          };
          userApi.resetPassword(this.userId, params).then(
              // eslint-disable-next-line no-unused-vars
              res => {
                this.$message.success({
                  message: "Password updated！",
                  type: "success"
                });
                this.$store.commit('SET_ASIDEHIDDEN', false)
                this.$router.go(-1); //返回上一层
              },
          );
        }
      });
    },
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.addForm {
  width: 500px;
}
</style>
